// Central marketing-site config. Store URLs stay empty until the apps are published.
const env = process.env;

export const STORE_URLS = {
  ios: env.REACT_APP_APP_STORE_URL || "",
  android: env.REACT_APP_PLAY_STORE_URL || "",
};

export const APP_LIVE = Boolean(STORE_URLS.ios || STORE_URLS.android);

export const API = `${env.REACT_APP_BACKEND_URL}/api`;

export const NAV_LINKS = [
  { label: "Platform", id: "platform" },
  { label: "For Artists", id: "for-artists" },
  { label: "Opportunities", id: "opportunities" },
  { label: "Pricing", id: "pricing" },
  { label: "About", id: "about" },
];

export const SOCIALS = [
  { label: "Instagram", href: "https://www.instagram.com/pitchallyapp/" },
  { label: "LinkedIn", href: "https://www.linkedin.com/company/pitchallyapp/" },
];

export const CONTACT_EMAIL = "support@pitchally.com";
export const ABOUT_URL = "https://pitchally.com/about";

export const storeUrlFor = (platform) => STORE_URLS[platform] || "";

export const waitlistLink = () => `${window.location.origin}/?join=waitlist`;

export const qrTarget = () => (APP_LIVE ? `${window.location.origin}/?get=app` : waitlistLink());
